import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import TaxContainer from '../../containers/profile/tax.container'
import PasswordContainer from '../../containers/profile/password.container'
import Snackbar from '@material-ui/core/Snackbar'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import UserSelectorContainer from '../../containers/layout/userSelector.container'
import { Translation } from 'react-i18next'
import { useForm, Form, Field, WatchField } from '../../form'
import { profileValidate } from '../../containers/validate'
import { scrollToTop } from '../../utils/scrollTo'
import WorkField from '../common/fieldOfWorkSelect'
import mobileView from '../../utils/mobile.utils'
import YelContainer from '../../containers/profile/yel.container'
import LogoContainer from '../../containers/profile/logo.container'
import ProfileDocuments from './profileDocuments.component'
import ValttiCardContainer from '../../containers/profile/valttiCard.container'
import ModalComponent from '../layout/modal.component'
import ChangeUserEmailContainer from '../../containers/profile/changeUserEmail.container'
import NavButton from '../openforwork/navButton.component'
import VerificationInfoMessage from './verificationInfo'
import IconTooltip from '../../utils/IconTooltip'

class ProfileComponent extends React.Component {
  componentDidMount() {
    if (this.props.userType == 2) {
      this.props.getUserInfo(this.props.selectedUser)
      this.props.getAdminUsersList()
    }
    this.props.getFieldOfWork()
    this.props.loadProfileStart()
    this.props.getLogo()
    this.props.getUserCompanyUpdateInfo()
    this.props.getTaxCard()
    scrollToTop()
  }

  componentDidUpdate() {
    if (this.props.scrollToSSN) {
      const element = document.getElementById('scroll-to-ssn')
      let headerOffset = document.getElementById('top-navbar').offsetHeight
      let elementPos = element.getBoundingClientRect().top + window.pageYOffset
      let offsetPos = elementPos - headerOffset

      window.scrollTo({
        top: offsetPos,
        behavior: 'smooth'
      })
      this.props.resetScrollToSSN()
    }
  }

  render() {
    return <Profile {...this.props} />
  }
}

const styles = (theme) => ({
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  select: {
    fontSize: '14px',
    border: '1px solid gray'
  },

  checkbox: {
    fontSize: '15px',
    fontWeight: 'bold',
    marginLeft: '15px',
    color: '#F67131'
  },
  marketNameOnInvoices: {
    marginRight: '30px',
    marginLeft: '-30px',
    fontSize: '14px',
    fontWeight: '510',
    color: '#808080'
  },
  button: {
    margin: `${theme.spacing(1)}px auto`,
    float: 'right',
    [theme.breakpoints.down('xs')]: {
      width: mobileView ? '75%' : '100%'
    },
    '@media (hover: none)': {
      '&:hover': {
        backgroundColor: '#F67131'
      }
    }
  },
  popUpBtn: {
    width: '15%',
    padding: '20px 20px',
    fontSize: '18px',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    },
    '@media (hover: none)': {
      '&:hover': {
        backgroundColor: '#F67131'
      }
    }
  },
  radioButton: {
    fontSize: '14px'
  },
  container:{
    position:'relative'
  },
  disabled:{
    border: '1px solid rgba(0, 0, 0, 0.20)',
  }
})

const defaultValues = {
  email: '',
  firstname: '',
  lastname: '',
  phone: '',
  account_number: '',
  salary_payment_option: 'auto_pay',
  //salary_payment_option: 'manual_pay',
  address: '',
  zip_code: '',
  city: '',
  market_name: '',
  job_title: '',
  ssn: '',
  useMarketName: false,
  field_work: ''
}

const Profile = ({
  updateProfile,
  showProfileSnackbar,
  showFailSnackbar,
  closeProfileSnackbar,
  classes,
  userType,
  selectedUser,
  fieldOfWork,
  showSsnWarningSnackbar,
  logoSaved,
  logoSaveFailed,
  deleteLogoSuccess,
  deleteLogoFailed,
  isInvalidLogo,
  isCorruptLogo,
  closeLogoSnackbar,
  userData,
  updateUserEmailSuccess,
  handlemanuallogout
}) => {
  const form = useForm({
    name: 'profile',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: profileValidate,
    resetOnSubmit: false
  })

  const { control, clearErrors } = form

  function onSubmit(values) {
    updateProfile(values)
  }

  const [open, setOpen] = useState(false)
  const [selectedContent, setSelectedContent] = useState(null)
  const [selectedMaxWidth, setSelectedMaxWidth] = useState(null)

  const handleOpenForm = (component, width = null) => {
    setSelectedContent(component)
    setSelectedMaxWidth(width)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setSelectedContent(null)
    setSelectedMaxWidth(null)
    if (updateUserEmailSuccess) {
      handlemanuallogout()
    }
  }

  return (
    <Translation>
      {(t) => {
        return (
          <div className="container">
            {open && (
              <ModalComponent
                open={open}
                onClose={handleClose}
                content={selectedContent}
                maxWidth={selectedMaxWidth}
              />
            )}
            {userType == 2 && <UserSelectorContainer></UserSelectorContainer>}

            <div className="row">
              <div className="dashboard-content-header">
                <h1></h1>
              </div>
            </div>

            <NavButton t={t} type="profile" />

            {/* <div className="row">
              <div className="dashboard-content-header">
                <h1>{t('profile.h1')}</h1>
              </div>
            </div> */}
            <div className="row">
              <Form {...form}>
                <div className="dashboard-content-header">
                  <div className="col-xs-12 col-sm-6 col-lg-6">
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h3 className="panel-title">
                          {t('profile.labelDetail')}
                        </h3>
                      </div>
                      <div className="panel-body">
                        <Field
                          name="lastname"
                          label={t('profile.label')}
                          inputType="textfield"
                          control={control}
                          className={classNames(
                            classes.textField,
                            classes.resize
                          )}
                        />
                        <Field
                          name="firstname"
                          label={t('profile.label2')}
                          inputType="textfield"
                          control={control}
                          className={classNames(
                            classes.textField,
                            classes.resize
                          )}
                        />
                        <Field
                          name="phone"
                          label={t('profile.label3')}
                          inputType="textfield"
                          control={control}
                          className={classNames(
                            classes.textField,
                            classes.resize
                          )}
                        />
                        <Field
                          name="account_number"
                          label={t('profile.label4')}
                          inputType="textfield"
                          control={control}
                          disabled={userType == 3 ? true : false}
                          className={classNames(
                            classes.textField,
                            classes.resize
                          )}
                        />

                        {/* {<div>
                          <p
                            style={{
                              marginTop: '22px',
                              color: '#696969',
                              fontSize: '15px'
                            }}
                          >
                            {t('profile.label12')}
                          </p>
                          <Field
                            name="salary_payment_option"
                            inputType="radiogroup"
                            className={classes.radioButton}
                            options={[
                              {
                                label: t('profile.label13'),
                                value: 'manual_pay'
                              },
                              {
                                label: t('profile.label14'),
                                value: 'auto_pay'
                              }
                            ]}
                            control={control}
                          />
                        </div>}
 */}
                        <div id="scroll-to-ssn" />
                        <div className={classes.container}>
                          <IconTooltip
                            tooltipShow={t('profile.ssnInfo')}
                            style={{
                              position: 'absolute',
                              top: '2rem',
                              right: '0rem',
                              zIndex: '500'
                            }}
                          />
                          <Field
                            name="ssn"
                            label={t('profile.label5')}
                            inputType="textfield"
                            control={control}
                            className={classNames(
                              classes.textField,
                              classes.resize,
                              classes.disabled
                            )}
                            placeholder={t('profile.label5a')}
                            disabled={true}
                            disableUnderline={true}
                          />
                        </div>
                      </div>
                    </div>

                    {userData && userData.is_verified ? (
                      <VerificationInfoMessage
                        isVerified={userData.is_verified}
                      />
                    ) : null}
                  </div>
                  <div className="col-xs-12 col-sm-6 col-lg-6">
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h3 className="panel-title">
                          {t('profile.labelAddDetail')}
                        </h3>
                      </div>
                      <div className="panel-body">
                        <Field
                          name="address"
                          label={t('profile.label6')}
                          inputType="textfield"
                          control={control}
                          className={classNames(
                            classes.textField,
                            classes.resize
                          )}
                        />
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between'
                          }}
                        >
                          <div style={{ width: '40%' }}>
                            <Field
                              name="zip_code"
                              label={t('profile.label7')}
                              inputType="textfield"
                              control={control}
                              className={classNames(
                                classes.textField,
                                classes.resize
                              )}
                            />
                          </div>
                          <div style={{ width: '56%' }}>
                            <Field
                              name="city"
                              label={t('profile.label8')}
                              inputType="textfield"
                              control={control}
                              className={classNames(
                                classes.textField,
                                classes.resize
                              )}
                            />
                          </div>
                        </div>
                        <Field
                          name="job_title"
                          label={t('profile.label10')}
                          inputType="textfield"
                          control={control}
                          className={classNames(
                            classes.textField,
                            classes.resize
                          )}
                        />
                        {/* KAS-342 If useMarketName is true, market_name is required */}
                        <WatchField control={control} fields="useMarketName">
                          {(watch) => (
                            <Field
                              name="market_name"
                              label={
                                watch.useMarketName === true
                                  ? t('profile.label9') + '*'
                                  : t('profile.label9')
                              }
                              inputType="textfield"
                              control={control}
                              className={classNames(
                                classes.textField,
                                classes.resize
                              )}
                            />
                          )}
                        </WatchField>
                        <WorkField
                          classes={classes}
                          fieldOfWork={fieldOfWork}
                          control={control}
                        />
                      </div>
                    </div>
                    <div
                      className="col-xs-12 col-sm-12 col-lg-12"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: '15px'
                      }}
                    >
                      <Field
                        name="useMarketName"
                        label={t('profile.useMarketName')}
                        inputType="checkbox"
                        control={control}
                        className={
                          (classes.checkbox,
                          classes.resize,
                          classes.marketNameOnInvoices)
                        }
                        // KAS-342 clear error when useMarketName is uncheck
                        onChange={(e) => {
                          if (!e.target.checked) {
                            clearErrors(['market_name'])
                          }
                        }}
                      />
                      <Button
                        variant="contained"
                        type="submit"
                        className={classes.button}
                        disabled={
                          userType == 2 && selectedUser.email == undefined
                            ? true
                            : false
                        }
                      >
                        {t('profile.label11')}
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
            {userData && !userData.is_verified ? (
              <VerificationInfoMessage isVerified={userData.is_verified} />
            ) : null}

            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showProfileSnackbar}
              autoHideDuration={2000}
              onClose={() => {
                closeProfileSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeProfileSnackbar()
                }}
                variant="success"
                message={t('profile.msg')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showFailSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                closeProfileSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeProfileSnackbar()
                }}
                variant="error"
                message={t('profile.msg2')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showSsnWarningSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                closeProfileSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeProfileSnackbar()
                }}
                variant="error"
                message={t('profile.msg3')}
              />
            </Snackbar>
            {createSnackBar(
              logoSaved,
              t('profile.logoSaveSuccess'),
              'success',
              2000,
              closeLogoSnackbar
            )}
            {createSnackBar(
              deleteLogoSuccess,
              t('profile.deleteLogoSuccess'),
              'success',
              2000,
              closeLogoSnackbar
            )}
            {createSnackBar(
              logoSaveFailed,
              t('profile.logoSaveFailed'),
              'error',
              4000,
              closeLogoSnackbar
            )}
            {createSnackBar(
              deleteLogoFailed,
              t('profile.deleteLogoFailed'),
              'error',
              4000,
              closeLogoSnackbar
            )}
            {createSnackBar(
              isInvalidLogo || isCorruptLogo,
              isInvalidLogo
                ? t('profile.invalidLogoFormat')
                : t('profile.corruptLogo'),
              'error',
              8000,
              closeLogoSnackbar
            )}
            <div style={{ display: 'block' }}>
              <div className="dashboard-content-header">
                <h1>{t('profile.buttonTitle1')}</h1>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: 24,
                  justifyContent: 'center',
                  marginBottom: 56
                }}
              >
                <Button
                  variant="contained"
                  className={classNames(classes.popUpBtn)}
                  onClick={() => handleOpenForm(<TaxContainer />, '1000px')}
                >
                  {t('taxComponent.h3')}
                </Button>
                <Button
                  variant="contained"
                  className={classNames(classes.popUpBtn)}
                  onClick={() => handleOpenForm(<YelContainer />, '600px')}
                >
                  {t('dashboarInfo.yel')}
                </Button>
                <Button
                  variant="contained"
                  className={classNames(classes.popUpBtn)}
                  onClick={() =>
                    handleOpenForm(<ValttiCardContainer t={t} />, '850px')
                  }
                >
                  {t('profile.valttiBtn')}
                </Button>
              </div>
              <div className="dashboard-content-header">
                <h1>{t('profile.buttonTitle2')}</h1>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: 24,
                  justifyContent: 'center',
                  marginTop: 16
                }}
              >
                <Button
                  variant="contained"
                  className={classNames(classes.popUpBtn)}
                  onClick={() => handleOpenForm(<PasswordContainer />, '600px')}
                >
                  {t('profile.password')}
                </Button>
                <Button
                  variant="contained"
                  className={classNames(classes.popUpBtn)}
                  onClick={() =>
                    handleOpenForm(<ChangeUserEmailContainer />, '600px')
                  }
                >
                  {t('profile.changeEmail')}
                </Button>
                <Button
                  variant="contained"
                  className={classNames(classes.popUpBtn)}
                  onClick={() => handleOpenForm(<LogoContainer />)}
                >
                  {t('profile.logoBtn')}
                </Button>
                <Button
                  variant="contained"
                  className={classNames(classes.popUpBtn)}
                  onClick={() => handleOpenForm(<ProfileDocuments t={t} />)}
                >
                  {t('insurance.h1')}
                </Button>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

export const createSnackBar = (
  condition,
  message,
  variant,
  autoHideDuration,
  onClose
) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      open={condition}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
    >
      <MySnackbarContentWrapper
        onClose={onClose}
        variant={variant}
        message={message}
      />
    </Snackbar>
  )
}

ProfileComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ProfileComponent)
